import React from 'react'
import { Card } from './Card'
import { CalendarIcon } from './CalendarIcon'
import { CardProps } from './types'

export const NoCallCard = ({ onButtonPress }: CardProps) => {
  return (
    <Card
      icon={<CalendarIcon variant="plus" />}
      title="1-on-1 Coaching Call"
      description="Find a time that works for you"
      buttonTitle="Book your next call"
      onCardPress={onButtonPress}
      onButtonPress={onButtonPress}
    />
  )
}
